import { createContext, useState, useEffect, FC } from 'react';
import { useLocation } from 'react-router';
import API from '../api/api';

export enum EChangeEmailUiState {
    default,
    error,
    success,
}

type TChangeEmailContext = {
    changeEmailUiState: EChangeEmailUiState;
    email: string;
};

const ChangeEmailContext = createContext<TChangeEmailContext | undefined>(undefined);

export const ChangeEmailProvider: FC = ({ children }) => {
    const [changeEmailUiState, setChangeEmailUiState] = useState(EChangeEmailUiState.default);
    const [email, setEmail] = useState('');
    const { search: queryParams } = useLocation();

    const getChangeEmail = async () => {
        try {
            const response = await API.get.changeEmail(queryParams);
            setEmail(response.data.email);
            setChangeEmailUiState(EChangeEmailUiState.success);
        } catch {
            setChangeEmailUiState(EChangeEmailUiState.error);
        }
    };

    useEffect(() => {
        getChangeEmail();
    }, []);

    return <ChangeEmailContext.Provider value={{ changeEmailUiState, email }}>{children}</ChangeEmailContext.Provider>;
};

export default ChangeEmailContext;
